'use client';
export { default } from './components/privacy';
